//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

	export default{
        props: {
            eventHub: Object
        },
    created(){
      this.matchId = this.$route.query.matchId;
      this.homeTeamId = this.$route.query.homeTeamId;
      this.visitTeamId = this.$route.query.visitTeamId;
    },
		data(){
			return{
				content:'时间轴',
        matchId: '',
        homeTeamId: '',
        visitTeamId: '',
        timeLineContent:[],
        homeTeamHeader:'this.src="' + require('../../assets/img/homeTeamHeader.svg') + '"',
        visitTeamHeader:'this.src="' + require('../../assets/img/visitTeamHeader.svg') + '"',
        defaultHeaderImg:require('../../assets/img/leagueDefaultLogo.svg'),
        goalSvg:require('../../assets/img/matchInfo/goal.svg'),
        assistSvg:require('../../assets/img/matchInfo/assist.svg'),
        changeinSvg:require('../../assets/img/matchInfo/changein.svg'),
        changeoutSvg:require('../../assets/img/matchInfo/changeout.svg'),
        owngoalSvg:require('../../assets/img/matchInfo/own-goal.svg'),
        pkgoalSvg:require('../../assets/img/matchInfo/pk-miss.svg'),
			}
		},
    mounted(){
      this.hagkHttp(this.hagkApi.getRosterMatchInfo(this.matchId, this.homeTeamId, this.visitTeamId), {})
        .then((res) => {
          for(var i=0;i<res.length;i++){
            res[i].time = Math.round(res[i].time/60);
            res[i].inAssetId = this.getimgUrl(res[i].inAssetId, res[i].registeredTeamId);
            if(res[i].inAssetId.indexOf('../assets/img/homeTeamHeader.svg') != -1 || res[i].inAssetId.indexOf('../assets/img/visitTeamHeader.svg') != -1){
              res[i].inLoadImgFail = true;
            } else{
              res[i].inLoadImgFail = false;
            }
            res[i].outAssetId = this.getimgUrl(res[i].outAssetId, res[i].registeredTeamId);
            if(res[i].outAssetId.indexOf('../assets/img/homeTeamHeader.svg') != -1 || res[i].inAssetId.indexOf('../assets/img/visitTeamHeader.svg') != -1){
              res[i].outLoadImgFail = true;
            } else{
              res[i].outLoadImgFail = false;
            }
            if(res[i].homeName && res[i].homeName.length>4)
              res[i].homeName = res[i].homeName.substring(0,3)+"…";
            if(res[i].visitName && res[i].visitName.length>4)
              res[i].visitName = res[i].visitName.substring(0,3)+"…";
            if(res[i].category == 0){
              res[i].category_url = this.goalSvg;
              if(res[i].visitNumber != null){
                res[i].assist_category_url = this.assistSvg;
              }
            } else if(res[i].category == 1){
              res[i].category_url = this.assistSvg;
            } else if(res[i].category == 2){
              if(res[i].type == 'red'){
                res[i].category_url = require('../../assets/img/matchInfo/red-card.svg')
              } else if(res[i].type == 'yellow'){
                res[i].category_url = require('../../assets/img/matchInfo/yellow-card.svg');
              }
            } else if(res[i].category == 3){
              res[i].in_category_url = this.changeinSvg;
              res[i].out_category_url = this.changeoutSvg;
            } else if(res[i].category == 4){
              // res[i].category_url = this.owngoalSvg;
              res[i].category_url = this.pkgoalSvg;
            } else if(res[i].category == 5){
              res[i].category_url = this.pkgoalSvg;
            }
          }
          this.timeLineContent = res;
          this.eventHub.$emit("resetView");
        }, (error) => {
          console.log(error);
          window.alert('比赛信息获取失败！');
        })
    },
    methods:{
      getimgUrl(assetId, teamId) {
        if (assetId && assetId != null) {
          return this.hagkApi.getImgAsset(assetId+'.jpg').url;
        } else {
          if(teamId == this.homeTeamId)
            return '../../assets/img/homeTeamHeader.svg';
          else if(teamId == this.visitTeamId)
            return '../../assets/img/visitTeamHeader.svg';
        }
      },
    }
	}



// WEBPACK FOOTER //
// ./src/components/match/timeLine.vue